import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/en';

// 網站語系 → dayjs 語系；沒列到的語系（日文、馬來文）沿用目前的 dayjs 語系
const DAYJS_LOCALES: Record<string, string> = {
  'zh-TW': 'zh-tw',
  'zh-CN': 'zh-cn',
  'en-US': 'en',
};

/** 讓相對時間等日期文字跟著網站語系；由 i18n 在語系變更時統一呼叫。 */
export const syncDayjsLocale = function (lang: string | undefined): void {
  const locale = lang ? DAYJS_LOCALES[lang] : undefined;
  if (locale) {
    dayjs.locale(locale);
  }
};
